import axios from 'axios';

const state = {
  categories: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null
  }
};

const actions = {
  async fetchCategories({ commit, dispatch }, params) {
    dispatch('loading/showLoading', null, { root: true });
    
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/category`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: params
      });
      const data = await response.data;
      commit('setCategories', data);
      commit('setPagination', data.pagination);
      return data;
    }
    catch (error) {
      console.error('Failed to fetch categories: ', error);
    }
    finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },
  createCategory({commit}, category) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('auth_token');
      axios.post(`${process.env.VUE_APP_ROOT_API}/category`, category, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        const data = response.data;
        commit('addCategory', data);
        resolve(data);
      })
      .catch(error => {
        console.error('Failed to create category', error);
        reject(error);
      });
    });
  },
  async updateCategory({ commit }, category) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/category/${category.id}`, category, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      commit('updateCategory', response.data);
    }
    catch (error) {
      console.error('Failed to update category:', error);
      throw error;
    }
  },
  async deleteCategoryById({ commit }, id) {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem('auth_token');
        axios.delete(`${process.env.VUE_APP_ROOT_API}/category/${id}`, {
          headers: {
          'Authorization': `Bearer ${token}`
          }
        })
        .then(response => {
          commit('removeCategory', id);
          resolve(response.data);
        })
        .catch(error => {
          console.error('Failed to delete category', error);
          reject(error);
        });
    });
  }
}

const mutations = {
  setCategories(state, categories) {
    state.categories = categories.data;
  },
  addCategory(state, category) {
    state.categories.push(category);
  },
  updateCategory(state, updatedCategory) {
    const index = state.categories.findIndex(category => category.id == updatedCategory.id);
    if (index !== -1) {
      state.categories.splice(index, 1, updatedCategory);
    }
  },
  removeCategory(state, id) {
    state.categories = state.categories.filter(category => category.id !== id);
  },
  setPagination(state, pagination) {
    state.pagination.page = pagination.page || 1;
    state.pagination.perPage = pagination.perPage || 10;
    state.pagination.totalItems = pagination.totalItems || 0;

    state.pagination.previousPageLink = pagination.previousPageLink ? pagination.previousPageLink.replace(/\/api\/v1\/category\?/, '') : null;
    state.pagination.nextPageLink = pagination.nextPageLink ? pagination.nextPageLink.replace(/\/api\/v1\/category\?/, '') : null;
  },
}

const getters = {
  allCategories: (state) => state.categories,
  pagination: (state) => state.pagination
};

export default {
  namespaced:true,
  state, mutations, actions, getters,
};  